/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 3.2.1263 on 2024-10-29 16:53:27.

export interface CreateAgentRequestDto {
    id: string;
    name: string;
    isActive: boolean;
}

export interface WebUUIDResponse {
    result: string; problemResponseData?: ProblemResponseData|null;
}

export interface AddAgentsDiscountByIdRequestDto extends RequestHeaderInfoDtoBase {
    agentIds: string[];
    discountId: string;
}

export interface WebBooleanResponse {
    result: boolean; problemResponseData?: ProblemResponseData|null;
}

export interface AddAgentDiscountForAllRequestDto extends RequestHeaderInfoDtoBase {
    discountId: string;
}

export interface AddAgentsPricelistByIdRequestDto extends RequestHeaderInfoDtoBase {
    agentIds: string[];
    pricelistId: string;
}

export interface AddAgentPricelistForAllRequestDto extends RequestHeaderInfoDtoBase {
    pricelistId: string;
}

export interface CreateClientRequestDto {
    id: string;
    name: string;
    isActive: boolean;
    accounts: string[];
}

export interface AddClientsDiscountByIdRequestDto {
    clientIds: string[];
    discountId: string;
}

export interface AddClientDiscountForAllRequestDto {
    discountId: string;
}

export interface AddClientsPricelistByIdRequestDto {
    clientIds: string[];
    pricelistId: string;
}

export interface AddClientPricelistForAllRequestDto {
    pricelistId: string;
}

export interface ActivateDiscountRequestDto {
    discountId: string;
    username: string;
}

export interface CreateDiscountRequestDto {
    name: string;
    description: string;
    discountType: DiscountType;
    validFromDateTime: DateAsString;
    validToDateTime: DateAsString;
    createdByName: string;
    serviceTypeId: string;
}

export interface CloseDiscountRequestDto {
    discountId: string;
    reason: string;
    username: string;
}

export interface DeactivateDiscountRequestDto {
    discountId: string;
    username: string;
}

export interface FinishCreatingDiscountRequestDto {
    discountId: string;
    username: string;
}

export interface FinishFormingDiscountRequestDto {
    discountId: string;
    username: string;
}

export interface FinishSettingDiscountDefinitionRequestDto {
    discountId: string;
    username: string;
}

export interface GetFilteredDiscountsRequestDto {
    serviceTypeId: string;
    name: string;
    activeOn: DateAsString;
    agentName: string;
    locationName: string;
    discountStateType: DiscountStateType;
    paginationData: PaginationRequestCommon;
    sortBy: string;
    ascending: boolean;
}

export interface HardDeleteDiscountRequestDto {
    discountId: string;
}

export interface SoftDeleteDiscountRequestDto {
    discountId: string;
    username: string;
}

export interface UpdateDiscountRequestDto {
    discountId: string;
    name: string;
    discountType: DiscountType;
    description: string;
    validFromDateTime: DateAsString;
    validToDateTime: DateAsString;
    updatedByName: string;
}

export interface UpdateDiscountDefinitionDto {
    discountId: string;
    allowedAttributes: FilteredAttributeForDefinitionRequestDto[];
    username: string;
}

export interface UpdateDiscountItemsRequestDto {
    discountId: string;
    discountItemDtos: CreateDiscountItemRequestDto[];
    username: string;
}

export interface RejectDiscountRequestDto {
    discountId: string;
    reason: string;
    username: string;
}

export interface ReturnDiscountForUpdateRequestDto {
    discountId: string;
    username: string;
}

export interface VerifyDiscountRequestDto {
    discountId: string;
    username: string;
}

export interface AddLocationsDiscountByIdRequestDto {
    locationIds: string[];
    discountId: string;
}

export interface AddLocationDiscountForAllRequestDto {
    discountId: string;
}

export interface CreateLocationRequestDto {
    name: string;
    agentId: string;
}

export interface AddLocationsPricelistByIdRequestDto {
    locationIds: string[];
    pricelistId: string;
}

export interface AddLocationPricelistForAllRequestDto {
    pricelistId: string;
}

export interface CreateAttributeRequestDto {
    display: string;
    key: string;
    isRange: boolean;
    serviceTypeId: string;
    attributeValues: { [index: string]: string };
}

export interface ActivatePricelistRequestDto {
    pricelistId: string;
    username: string;
}

export interface CreatePricelistRequestDto {
    name: string;
    description: string;
    pricelistType: PricelistType;
    validFromDateTime: DateAsString;
    validToDateTime: DateAsString;
    createdByName: string;
    serviceTypeId: string;
}

export interface ClosePricelistRequestDto {
    pricelistId: string;
    reason: string;
    username: string;
}

export interface DeactivatePricelistRequestDto {
    pricelistId: string;
    username: string;
}

export interface FinishCreatingPricelistRequestDto {
    pricelistId: string;
    username: string;
}

export interface FinishFormingPricelistRequestDto {
    pricelistId: string;
    username: string;
}

export interface FinishSettingPricelistDefinitionRequestDto {
    pricelistId: string;
    username: string;
}

export interface GetFilteredPricelistsRequestDto {
    serviceTypeId: string;
    name: string;
    activeFrom: DateAsString;
    activeTo: DateAsString;
    agentName: string;
    locationName: string;
    clientName: string;
    referenceNumber: string;
    pricelistStateType: PricelistStateType;
    pricelistType: PricelistType;
    paginationData: PaginationRequestCommon;
    sortBy: string;
    ascending: boolean;
}

export interface HardDeletePricelistRequestDto {
    pricelistId: string;
}

export interface SoftDeletePricelistRequestDto {
    pricelistId: string;
    username: string;
}

export interface UpdatePricelistRequestDto {
    pricelistId: string;
    name: string;
    pricelistType: PricelistType;
    description: string;
    validFromDateTime: DateAsString;
    validToDateTime: DateAsString;
    updatedByName: string;
}

export interface UpdatePricelistDefinitionDto {
    pricelistId: string;
    allowedAttributes: FilteredAttributeForDefinitionRequestDto[];
    username: string;
}

export interface UpdatePricelistItemsRequestDto {
    pricelistId: string;
    pricelistItemDtos: CreatePricelistItemRequestDto[];
    username: string;
}

export interface RejectPricelistRequestDto {
    pricelistId: string;
    reason: string;
    username: string;
}

export interface ReturnPricelistForUpdateRequestDto {
    pricelistId: string;
    username: string;
}

export interface VerifyPricelistRequestDto {
    pricelistId: string;
    username: string;
}

export interface CreateServiceTypeRequestDto {
    name: string;
    serviceTypeCode: string;
}

export interface WebResponseObject<T> extends WebResponseBase {
    result: T;
}

export interface RequestHeaderBaseInfo {
    userType: RequestUserType;
    appInfo: RequestApplicationInfo;
    masterAgentInfo: RequestMasterAgentInfo;
    userInfo: RequestUserInfo;
    agentInfo: RequestAgentInfo;
    merchantInfo: RequestMerchantInfo;
}

export interface RequestHeaderInfoDtoBase {
    requestHeaderInfo: RequestHeaderBaseInfo;
}

export interface WebResponseEntity<T> {
    result: T; problemResponseData?: ProblemResponseData|null;
}

export interface GetAgentResponseDto {
    agent: AgentCommon;
}

export interface GetAllAgentsResponseDto {
    agents: AgentCommon[];
}

export interface GetAllClientsResponseDto {
    clients: ClientCommon[];
}

export interface GetClientResponseDto {
    client: ClientCommon;
}

export interface GetAllDiscountsResponseDto {
    discounts: DiscountCommon[];
}

export interface GetDiscountResponseDto {
    discount: DiscountCommon;
}

export interface PaginationRequestCommon {
    currentPage: number;
    itemsPerPage: number;
}

export interface GetFilteredDiscountsResponseDto {
    discounts: DiscountCommon[];
    totalCount: number;
}

export interface FilteredAttributeForDefinitionRequestDto {
    attributeId: string;
    allowedValuesId: string[];
}

export interface CreateDiscountItemRequestDto {
    attributeInstanceDtos: CreateAttributeInstanceRequestDto[];
    amountFrom: number;
    amountTo: number;
    fixedFee: number;
    percentageFee: number;
    minimalFee: number;
    maximalFee: number;
}

export interface GetAllLocationsResponseDto {
    locations: LocationCommon[];
}

export interface GetAllLocationsByAgentIdResponseDto {
    locations: LocationCommon[];
}

export interface GetLocationResponseDto {
    location: LocationCommon;
}

export interface GetAllAttributesResponseDto {
    attributeCommons: AttributeCommon[];
}

export interface GetAllAttributesByServiceTypeIdResponseDto {
    attributeCommons: AttributeCommon[];
}

export interface GetAttributeResponseDto {
    attributeCommon: AttributeCommon;
}

export interface GetAllPricelistsResponseDto {
    pricelists: PricelistCommon[];
}

export interface GetFilteredPricelistsResponseDto {
    pricelists: PricelistCommon[];
    totalCount: number;
}

export interface GetPricelistResponseDto {
    pricelist: PricelistCommon;
}

export interface CreatePricelistItemRequestDto {
    attributeInstanceDtos: CreateAttributeInstanceRequestDto[];
    amountFrom: number;
    amountTo: number;
    fixedFee: number;
    percentageFee: number;
    minimalFee: number;
    maximalFee: number;
    taxRate: number;
}

export interface GetAllServiceTypesResponseDto {
    serviceTypes: ServiceTypeCommon[];
}

export interface GetServiceTypeResponseDto {
    serviceType: ServiceTypeCommon;
}

export interface ProblemResponseData extends Serializable {
    error: boolean;
    problems: ProblemBase[];
}

export interface WebResponseBase extends Serializable {
    problemResponseData: ProblemResponseData;
}

export interface RequestApplicationInfo extends RequestInfo {
    serviceRequest: boolean;
    applicationId: string;
    language: string;
}

export interface RequestMasterAgentInfo extends RequestInfo {
    masterAgentAccessId: string;
    country: string;
}

export interface RequestUserInfo extends RequestInfo {
    userId: string;
    requestPermission: number;
    subservicePermission: number;
}

export interface RequestAgentInfo extends RequestInfo {
    terminalId: string;
    locationId: string;
    agentId: string;
}

export interface RequestMerchantInfo extends RequestInfo {
    merchantId: string;
}

export interface AgentCommon {
    id: string;
    name: string;
    pricelistIds: string[];
    discountIds: string[];
}

export interface ClientCommon {
    id: string;
    name: string;
    isActive: boolean;
    pricelistIds: string[];
    discountIds: string[];
    accounts: string[];
}

export interface DiscountCommon {
    id: string;
    referenceNumber: string;
    discountType: DiscountType;
    name: string;
    description: string;
    validFromDateTime: DateAsString;
    validToDateTime: DateAsString;
    createdAtDateTime: DateAsString;
    createdByName: string;
    updatedAtDateTime: DateAsString;
    updatedByName: string;
    discountStateType: string;
    discountAllowedActions: string[];
    discountEditSnapshot: DiscountEditSnapshotCommon;
    discountDefinition: DiscountDefinitionCommon;
    discountItems: DiscountItemCommon[];
    discountStateChanges: DiscountStateChangeCommon[];
    activeOnAgents: string[];
    activeOnLocations: string[];
    activeOnClients: string[];
    assignedToAgents: string[];
    assignedToLocations: string[];
    assignedToClients: string[];
    serviceType: ServiceTypeCommon;
}

export interface CreateAttributeInstanceRequestDto {
    rangeStart: number;
    rangeEnd: number;
    attributeId: string;
    attributeValueId: string;
}

export interface LocationCommon {
    id: string;
    name: string;
    agentId: string;
    pricelistIds: string[];
    discountIds: string[];
}

export interface AttributeCommon {
    id: string;
    display: string;
    key: string;
    isRange: boolean;
    serviceType: ServiceTypeCommon;
    attributeValues: AttributeValueCommon[];
}

export interface PricelistCommon {
    id: string;
    referenceNumber: string;
    pricelistType: PricelistType;
    name: string;
    description: string;
    validFromDateTime: DateAsString;
    validToDateTime: DateAsString;
    createdAtDateTime: DateAsString;
    createdByName: string;
    updatedAtDateTime: DateAsString;
    updatedByName: string;
    pricelistStateType: string;
    reason: string;
    pricelistAllowedActions: string[];
    pricelistEditSnapshot: PricelistEditSnapshotCommon;
    pricelistDefinition: PricelistDefinitionCommon;
    pricelistItems: PricelistItemCommon[];
    pricelistStateChanges: PricelistStateChangeCommon[];
    activeOnAgents: string[];
    activeOnLocations: string[];
    activeOnClients: string[];
    assignedToAgents: string[];
    assignedToLocations: string[];
    assignedToClients: string[];
    serviceType: ServiceTypeCommon;
}

export interface ServiceTypeCommon {
    id: string;
    name: string;
}

export interface ProblemBase extends Serializable {
    problemCode: number;
    applicationOrigin: string;
    exceptionCode: string;
    message: string;
    details: string;
    type: string;
}

export interface Serializable {
}

export interface RequestInfo {
}

export interface ResponseEntity<T> {
    result: T;
    problemResponseData?: ProblemResponseData|null;
}

export interface DiscountEditSnapshotCommon {
    id: string;
    name: string;
    description: string;
    validFromDateTime: DateAsString;
    validToDateTime: DateAsString;
    updatedByName: string;
    updatedAtDateTime: DateAsString;
    pricelistId: string;
}

export interface DiscountDefinitionCommon {
    id: string;
    discountAttributes: AttributeCommon[];
    attributeAllowedValues: AttributeValueCommon[];
    discountId: string;
}

export interface DiscountItemCommon {
    id: string;
    amountFrom: number;
    amountTo: number;
    fixedFee: number;
    percentageFee: number;
    minimalFee: number;
    maximalFee: number;
    discountId: string;
    attributeInstanceCommons: AttributeInstanceCommon[];
}

export interface DiscountStateChangeCommon {
    id: string;
    discountId: string;
    discountStateType: DiscountStateType;
    stateChangeDateTime: DateAsString;
    changedByUser: string;
}

export interface AttributeValueCommon {
    id: string;
    display: string;
    value: string;
    attributeId: string;
    serviceTypeId: string;
    pricelistDefinitionIds: string[];
    discountDefinitionIds: string[];
}

export interface PricelistEditSnapshotCommon {
    id: string;
    name: string;
    description: string;
    validFromDateTime: DateAsString;
    validToDateTime: DateAsString;
    updatedByName: string;
    updatedAtDateTime: DateAsString;
    pricelistId: string;
}

export interface PricelistDefinitionCommon {
    id: string;
    pricelistAttributes: AttributeCommon[];
    attributeAllowedValues: AttributeValueCommon[];
    pricelistId: string;
}

export interface PricelistItemCommon {
    id: string;
    amountFrom: number;
    amountTo: number;
    fixedFee: number;
    percentageFee: number;
    minimalFee: number;
    maximalFee: number;
    taxRate: number;
    pricelistId: string;
    attributeInstanceCommons: AttributeInstanceCommon[];
}

export interface PricelistStateChangeCommon {
    id: string;
    pricelistId: string;
    pricelistStateType: PricelistStateType;
    stateChangeDateTime: DateAsString;
    changedByUser: string;
    rejectionReason: string;
    closingReason: string;
}

export interface AttributeInstanceCommon {
    id: string;
    rangeStart: number;
    rangeEnd: number;
    attributeValue: AttributeValueCommon;
    attribute: AttributeCommon;
}

export interface HttpEntity<T> {
    headers: { [index: string]: string[] };
    body: T;
}

export interface HttpClient<O> {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: O; }): RestResponse<R>;
}

export class RestApplicationClient<O> {

    constructor(protected httpClient: HttpClient<O>) {
    }

    /**
     * HTTP POST /pricing/agent/add-discount-by-id
     * Java method: com.europoint.pricing.web.controllers.AgentController.addDiscountByAgentId
     */
    addDiscountByAgentId$POST$pricing_agent_adddiscountbyid(addAgentPricelistByIdRequestDto: AddAgentsDiscountByIdRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/agent/add-discount-by-id`, data: addAgentPricelistByIdRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/agent/add-discount-for-all
     * Java method: com.europoint.pricing.web.controllers.AgentController.addDiscountForAllAgents
     */
    addDiscountForAllAgents$POST$pricing_agent_adddiscountforall(addAgentPricelistForAllRequestDto: AddAgentDiscountForAllRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/agent/add-discount-for-all`, data: addAgentPricelistForAllRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/agent/add-pricelist-by-id
     * Java method: com.europoint.pricing.web.controllers.AgentController.addPricelistByAgentIds
     */
    addPricelistByAgentIds$POST$pricing_agent_addpricelistbyid(addAgentsPricelistByIdRequestDto: AddAgentsPricelistByIdRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/agent/add-pricelist-by-id`, data: addAgentsPricelistByIdRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/agent/add-pricelist-for-all
     * Java method: com.europoint.pricing.web.controllers.AgentController.addPricelistForAllAgents
     */
    addPricelistForAllAgents$POST$pricing_agent_addpricelistforall(addAgentPricelistForAllRequestDto: AddAgentPricelistForAllRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/agent/add-pricelist-for-all`, data: addAgentPricelistForAllRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/agent/create
     * Java method: com.europoint.pricing.web.controllers.AgentController.addAgent
     */
    addAgent(createAgentRequestDto: CreateAgentRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/agent/create`, data: createAgentRequestDto, options: options });
    }

    /**
     * HTTP GET /pricing/agent/get-all
     * Java method: com.europoint.pricing.web.controllers.AgentController.getAll
     */
    getAll$GET$pricing_agent_getall(options?: O): RestResponse<WebResponseEntity<GetAllAgentsResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/agent/get-all`, options: options });
    }

    /**
     * HTTP GET /pricing/agent/get/{ID}
     * Java method: com.europoint.pricing.web.controllers.AgentController.getAgentById
     */
    getAgentById(ID: string, options?: O): RestResponse<WebResponseEntity<GetAgentResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/agent/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /pricing/attribute/create
     * Java method: com.europoint.pricing.web.controllers.PricelistAttributeController.addPricelistAttribute
     */
    addPricelistAttribute(createAttributeRequestDto: CreateAttributeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/attribute/create`, data: createAttributeRequestDto, options: options });
    }

    /**
     * HTTP GET /pricing/attribute/get-all
     * Java method: com.europoint.pricing.web.controllers.PricelistAttributeController.getAll
     */
    getAll$GET$pricing_attribute_getall(options?: O): RestResponse<WebResponseEntity<GetAllAttributesResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/attribute/get-all`, options: options });
    }

    /**
     * HTTP GET /pricing/attribute/get-all-by-service-type-id/{ID}
     * Java method: com.europoint.pricing.web.controllers.PricelistAttributeController.getAllByServiceTypeId
     */
    getAllByServiceTypeId(ID: string, options?: O): RestResponse<WebResponseEntity<GetAllAttributesByServiceTypeIdResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/attribute/get-all-by-service-type-id/${ID}`, options: options });
    }

    /**
     * HTTP GET /pricing/attribute/get/{ID}
     * Java method: com.europoint.pricing.web.controllers.PricelistAttributeController.getPricelistAttribute
     */
    getPricelistAttribute(ID: string, options?: O): RestResponse<WebResponseEntity<GetAttributeResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/attribute/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /pricing/client/add-discount-by-id
     * Java method: com.europoint.pricing.web.controllers.ClientController.addDiscountByClientId
     */
    addDiscountByClientId(addClientPricelistByIdRequestDto: AddClientsDiscountByIdRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/client/add-discount-by-id`, data: addClientPricelistByIdRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/client/add-discount-for-all
     * Java method: com.europoint.pricing.web.controllers.ClientController.addDiscountForAllClients
     */
    addDiscountForAllClients(addClientPricelistForAllRequestDto: AddClientDiscountForAllRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/client/add-discount-for-all`, data: addClientPricelistForAllRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/client/add-pricelist-by-id
     * Java method: com.europoint.pricing.web.controllers.ClientController.addPricelistByClientId
     */
    addPricelistByClientId(addClientsPricelistByIdRequestDto: AddClientsPricelistByIdRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/client/add-pricelist-by-id`, data: addClientsPricelistByIdRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/client/add-pricelist-for-all
     * Java method: com.europoint.pricing.web.controllers.ClientController.addPricelistForAllClients
     */
    addPricelistForAllClients(addClientPricelistForAllRequestDto: AddClientPricelistForAllRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/client/add-pricelist-for-all`, data: addClientPricelistForAllRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/client/create
     * Java method: com.europoint.pricing.web.controllers.ClientController.addClient
     */
    addClient(createClientRequestDto: CreateClientRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/client/create`, data: createClientRequestDto, options: options });
    }

    /**
     * HTTP GET /pricing/client/get-all
     * Java method: com.europoint.pricing.web.controllers.ClientController.getAll
     */
    getAll$GET$pricing_client_getall(options?: O): RestResponse<WebResponseEntity<GetAllClientsResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/client/get-all`, options: options });
    }

    /**
     * HTTP GET /pricing/client/get/{ID}
     * Java method: com.europoint.pricing.web.controllers.ClientController.getClientById
     */
    getClientById(ID: string, options?: O): RestResponse<WebResponseEntity<GetClientResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/client/get/${ID}`, options: options });
    }

    /**
     * HTTP PUT /pricing/discount-provider-pricelist/reject
     * Java method: com.europoint.pricing.web.controllers.DiscountPlatformProviderController.rejectDiscount
     */
    rejectDiscount(rejectDiscountRequestDto: RejectDiscountRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`pricing/discount-provider-pricelist/reject`, data: rejectDiscountRequestDto, options: options });
    }

    /**
     * HTTP PUT /pricing/discount-provider-pricelist/return-for-update
     * Java method: com.europoint.pricing.web.controllers.DiscountPlatformProviderController.returnDiscountForUpdate
     */
    returnDiscountForUpdate(returnDiscountForUpdateRequestDto: ReturnDiscountForUpdateRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`pricing/discount-provider-pricelist/return-for-update`, data: returnDiscountForUpdateRequestDto, options: options });
    }

    /**
     * HTTP PUT /pricing/discount-provider-pricelist/verify
     * Java method: com.europoint.pricing.web.controllers.DiscountPlatformProviderController.verifyDiscount
     */
    verifyDiscount(verifyDiscountRequestDto: VerifyDiscountRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`pricing/discount-provider-pricelist/verify`, data: verifyDiscountRequestDto, options: options });
    }

    /**
     * HTTP PUT /pricing/discount/activate
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.activateDiscount
     */
    activateDiscount(activateDiscountRequestDto: ActivateDiscountRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`pricing/discount/activate`, data: activateDiscountRequestDto, options: options });
    }

    /**
     * HTTP PUT /pricing/discount/close
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.closeDiscount
     */
    closeDiscount(closeDiscountRequestDto: CloseDiscountRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`pricing/discount/close`, data: closeDiscountRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/discount/create
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.addDiscount
     */
    addDiscount(createDiscountRequestDto: CreateDiscountRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/discount/create`, data: createDiscountRequestDto, options: options });
    }

    /**
     * HTTP PUT /pricing/discount/deactivate
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.deactivateDiscount
     */
    deactivateDiscount(deactivateDiscountRequestDto: DeactivateDiscountRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`pricing/discount/deactivate`, data: deactivateDiscountRequestDto, options: options });
    }

    /**
     * HTTP PUT /pricing/discount/finish-creating
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.finishCreatingDiscount
     */
    finishCreatingDiscount(finishCreatingDiscountRequestDto: FinishCreatingDiscountRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`pricing/discount/finish-creating`, data: finishCreatingDiscountRequestDto, options: options });
    }

    /**
     * HTTP PUT /pricing/discount/finish-forming
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.finishFormingDiscount
     */
    finishFormingDiscount(finishFormingDiscountRequestDto: FinishFormingDiscountRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`pricing/discount/finish-forming`, data: finishFormingDiscountRequestDto, options: options });
    }

    /**
     * HTTP PUT /pricing/discount/finish-setting-discount-definition
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.finishSettingDiscountDefinition
     */
    finishSettingDiscountDefinition(finishSettingDiscountDefinitionRequestDto: FinishSettingDiscountDefinitionRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`pricing/discount/finish-setting-discount-definition`, data: finishSettingDiscountDefinitionRequestDto, options: options });
    }

    /**
     * HTTP GET /pricing/discount/get-all
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.getAll
     */
    getAll$GET$pricing_discount_getall(options?: O): RestResponse<WebResponseEntity<GetAllDiscountsResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/discount/get-all`, options: options });
    }

    /**
     * HTTP POST /pricing/discount/get-filtered
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.getFiltered
     */
    getFiltered$POST$pricing_discount_getfiltered(getFilteredDiscountsRequestDto: GetFilteredDiscountsRequestDto, options?: O): RestResponse<WebResponseEntity<GetFilteredDiscountsResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/discount/get-filtered`, data: getFilteredDiscountsRequestDto, options: options });
    }

    /**
     * HTTP GET /pricing/discount/get/{ID}
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.getDiscount
     */
    getDiscount(ID: string, options?: O): RestResponse<WebResponseEntity<GetDiscountResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/discount/get/${ID}`, options: options });
    }

    /**
     * HTTP DELETE /pricing/discount/hard-delete
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.hardDeleteDiscount
     */
    hardDeleteDiscount(hardDeleteDiscountRequestDto: HardDeleteDiscountRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`pricing/discount/hard-delete`, data: hardDeleteDiscountRequestDto, options: options });
    }

    /**
     * HTTP DELETE /pricing/discount/soft-delete
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.softDelete
     */
    softDelete$DELETE$pricing_discount_softdelete(softDeleteDiscountRequestDto: SoftDeleteDiscountRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`pricing/discount/soft-delete`, data: softDeleteDiscountRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/discount/update
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.updateDiscount
     */
    updateDiscount(updateDiscountRequestDto: UpdateDiscountRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/discount/update`, data: updateDiscountRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/discount/update-discount-definition
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.updateDiscountDefinition
     */
    updateDiscountDefinition(updateDiscountDefinitionDto: UpdateDiscountDefinitionDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/discount/update-discount-definition`, data: updateDiscountDefinitionDto, options: options });
    }

    /**
     * HTTP POST /pricing/discount/update-discount-items
     * Java method: com.europoint.pricing.web.controllers.DiscountMasterAgentController.updateDiscountItems
     */
    updateDiscountItems(updateDiscountItemsRequestDto: UpdateDiscountItemsRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/discount/update-discount-items`, data: updateDiscountItemsRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/location/add-discount-by-id
     * Java method: com.europoint.pricing.web.controllers.LocationController.addDiscountByAgentId
     */
    addDiscountByAgentId$POST$pricing_location_adddiscountbyid(addAgentPricelistByIdRequestDto: AddLocationsDiscountByIdRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/location/add-discount-by-id`, data: addAgentPricelistByIdRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/location/add-discount-for-all
     * Java method: com.europoint.pricing.web.controllers.LocationController.addDiscountForAllAgents
     */
    addDiscountForAllAgents$POST$pricing_location_adddiscountforall(addAgentPricelistForAllRequestDto: AddLocationDiscountForAllRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/location/add-discount-for-all`, data: addAgentPricelistForAllRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/location/add-pricelist-by-id
     * Java method: com.europoint.pricing.web.controllers.LocationController.addPricelistByAgentIds
     */
    addPricelistByAgentIds$POST$pricing_location_addpricelistbyid(addAgentPricelistByIdRequestDto: AddLocationsPricelistByIdRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/location/add-pricelist-by-id`, data: addAgentPricelistByIdRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/location/add-pricelist-for-all
     * Java method: com.europoint.pricing.web.controllers.LocationController.addPricelistForAllAgents
     */
    addPricelistForAllAgents$POST$pricing_location_addpricelistforall(addAgentPricelistForAllRequestDto: AddLocationPricelistForAllRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/location/add-pricelist-for-all`, data: addAgentPricelistForAllRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/location/create
     * Java method: com.europoint.pricing.web.controllers.LocationController.addLocation
     */
    addLocation(createLocationRequestDto: CreateLocationRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/location/create`, data: createLocationRequestDto, options: options });
    }

    /**
     * HTTP GET /pricing/location/get-all
     * Java method: com.europoint.pricing.web.controllers.LocationController.getAll
     */
    getAll$GET$pricing_location_getall(options?: O): RestResponse<WebResponseEntity<GetAllLocationsResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/location/get-all`, options: options });
    }

    /**
     * HTTP GET /pricing/location/get-all-by-agent-id/{agentId}
     * Java method: com.europoint.pricing.web.controllers.LocationController.getAllByAgentId
     */
    getAllByAgentId(agentId: string, options?: O): RestResponse<WebResponseEntity<GetAllLocationsByAgentIdResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/location/get-all-by-agent-id/${agentId}`, options: options });
    }

    /**
     * HTTP GET /pricing/location/get/{ID}
     * Java method: com.europoint.pricing.web.controllers.LocationController.getLocation
     */
    getLocation(ID: string, options?: O): RestResponse<WebResponseEntity<GetLocationResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/location/get/${ID}`, options: options });
    }

    /**
     * HTTP PUT /pricing/platform-provider-pricelist/reject
     * Java method: com.europoint.pricing.web.controllers.PricelistPlatformProviderController.rejectPricelist
     */
    rejectPricelist(rejectPricelistRequestDto: RejectPricelistRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`pricing/platform-provider-pricelist/reject`, data: rejectPricelistRequestDto, options: options });
    }

    /**
     * HTTP PUT /pricing/platform-provider-pricelist/return-for-update
     * Java method: com.europoint.pricing.web.controllers.PricelistPlatformProviderController.returnPricelistForUpdate
     */
    returnPricelistForUpdate(returnPricelistForUpdateRequestDto: ReturnPricelistForUpdateRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`pricing/platform-provider-pricelist/return-for-update`, data: returnPricelistForUpdateRequestDto, options: options });
    }

    /**
     * HTTP PUT /pricing/platform-provider-pricelist/verify
     * Java method: com.europoint.pricing.web.controllers.PricelistPlatformProviderController.verifyPricelist
     */
    verifyPricelist(verifyPricelistRequestDto: VerifyPricelistRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`pricing/platform-provider-pricelist/verify`, data: verifyPricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/activate
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.activatePricelist
     */
    activatePricelist(activatePricelistRequestDto: ActivatePricelistRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/activate`, data: activatePricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/close
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.closePricelist
     */
    closePricelist(closePricelistRequestDto: ClosePricelistRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/close`, data: closePricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/create
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.addPricelist
     */
    addPricelist(createPricelistRequestDto: CreatePricelistRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/create`, data: createPricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/deactivate
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.deactivatePricelist
     */
    deactivatePricelist(deactivatePricelistRequestDto: DeactivatePricelistRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/deactivate`, data: deactivatePricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/finish-creating
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.finishCreatingPricelist
     */
    finishCreatingPricelist(finishCreatingPricelistRequestDto: FinishCreatingPricelistRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/finish-creating`, data: finishCreatingPricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/finish-forming
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.finishFormingPricelist
     */
    finishFormingPricelist(finishFormingPricelistRequestDto: FinishFormingPricelistRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/finish-forming`, data: finishFormingPricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/finish-setting-definition
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.finishSettingPricelistDefinition
     */
    finishSettingPricelistDefinition(finishSettingPricelistDefinitionRequestDto: FinishSettingPricelistDefinitionRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/finish-setting-definition`, data: finishSettingPricelistDefinitionRequestDto, options: options });
    }

    /**
     * HTTP GET /pricing/price-list/get-all
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.getAll
     */
    getAll$GET$pricing_pricelist_getall(options?: O): RestResponse<WebResponseEntity<GetAllPricelistsResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/price-list/get-all`, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/get-filtered
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.getFiltered
     */
    getFiltered$POST$pricing_pricelist_getfiltered(getFilteredPricelistsRequestDto: GetFilteredPricelistsRequestDto, options?: O): RestResponse<WebResponseEntity<GetFilteredPricelistsResponseDto>> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/get-filtered`, data: getFilteredPricelistsRequestDto, options: options });
    }

    /**
     * HTTP GET /pricing/price-list/get/{ID}
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.getPricelist
     */
    getPricelist(ID: string, options?: O): RestResponse<WebResponseEntity<GetPricelistResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/price-list/get/${ID}`, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/hard-delete
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.hardDeletePricelist
     */
    hardDeletePricelist(hardDeletePricelistRequestDto: HardDeletePricelistRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/hard-delete`, data: hardDeletePricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/soft-delete
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.softDelete
     */
    softDelete$POST$pricing_pricelist_softdelete(softDeletePricelistRequestDto: SoftDeletePricelistRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/soft-delete`, data: softDeletePricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/update
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.updatePricelist
     */
    updatePricelist(updatePricelistRequestDto: UpdatePricelistRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/update`, data: updatePricelistRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/update-definition
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.updatePricelistDefinition
     */
    updatePricelistDefinition(updatePricelistDefinitionDto: UpdatePricelistDefinitionDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/update-definition`, data: updatePricelistDefinitionDto, options: options });
    }

    /**
     * HTTP POST /pricing/price-list/update-items
     * Java method: com.europoint.pricing.web.controllers.PricelistMasterAgentController.updatePricelistItems
     */
    updatePricelistItems(updatePricelistItemsRequestDto: UpdatePricelistItemsRequestDto, options?: O): RestResponse<WebBooleanResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/price-list/update-items`, data: updatePricelistItemsRequestDto, options: options });
    }

    /**
     * HTTP POST /pricing/service-type/create
     * Java method: com.europoint.pricing.web.controllers.ServiceTypeController.addServiceType
     */
    addServiceType(createServiceTypeRequestDto: CreateServiceTypeRequestDto, options?: O): RestResponse<WebUUIDResponse> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`pricing/service-type/create`, data: createServiceTypeRequestDto, options: options });
    }

    /**
     * HTTP GET /pricing/service-type/get-all
     * Java method: com.europoint.pricing.web.controllers.ServiceTypeController.getAll
     */
    getAll$GET$pricing_servicetype_getall(options?: O): RestResponse<WebResponseEntity<GetAllServiceTypesResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/service-type/get-all`, options: options });
    }

    /**
     * HTTP GET /pricing/service-type/get/{ID}
     * Java method: com.europoint.pricing.web.controllers.ServiceTypeController.getServiceType
     */
    getServiceType(ID: string, options?: O): RestResponse<WebResponseEntity<GetServiceTypeResponseDto>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`pricing/service-type/get/${ID}`, options: options });
    }
}

export type RestResponse<R> = Promise<Axios.GenericAxiosResponse<R>>;

export type DateAsString = string;

/**
 * Values:
 * - `CONTINUE`
 * - `SWITCHING_PROTOCOLS`
 * - `PROCESSING`
 * - `CHECKPOINT`
 * - `OK`
 * - `CREATED`
 * - `ACCEPTED`
 * - `NON_AUTHORITATIVE_INFORMATION`
 * - `NO_CONTENT`
 * - `RESET_CONTENT`
 * - `PARTIAL_CONTENT`
 * - `MULTI_STATUS`
 * - `ALREADY_REPORTED`
 * - `IM_USED`
 * - `MULTIPLE_CHOICES`
 * - `MOVED_PERMANENTLY`
 * - `FOUND`
 * - `MOVED_TEMPORARILY` - @deprecated
 * - `SEE_OTHER`
 * - `NOT_MODIFIED`
 * - `USE_PROXY` - @deprecated
 * - `TEMPORARY_REDIRECT`
 * - `PERMANENT_REDIRECT`
 * - `BAD_REQUEST`
 * - `UNAUTHORIZED`
 * - `PAYMENT_REQUIRED`
 * - `FORBIDDEN`
 * - `NOT_FOUND`
 * - `METHOD_NOT_ALLOWED`
 * - `NOT_ACCEPTABLE`
 * - `PROXY_AUTHENTICATION_REQUIRED`
 * - `REQUEST_TIMEOUT`
 * - `CONFLICT`
 * - `GONE`
 * - `LENGTH_REQUIRED`
 * - `PRECONDITION_FAILED`
 * - `PAYLOAD_TOO_LARGE`
 * - `REQUEST_ENTITY_TOO_LARGE` - @deprecated
 * - `URI_TOO_LONG`
 * - `REQUEST_URI_TOO_LONG` - @deprecated
 * - `UNSUPPORTED_MEDIA_TYPE`
 * - `REQUESTED_RANGE_NOT_SATISFIABLE`
 * - `EXPECTATION_FAILED`
 * - `I_AM_A_TEAPOT`
 * - `INSUFFICIENT_SPACE_ON_RESOURCE` - @deprecated
 * - `METHOD_FAILURE` - @deprecated
 * - `DESTINATION_LOCKED` - @deprecated
 * - `UNPROCESSABLE_ENTITY`
 * - `LOCKED`
 * - `FAILED_DEPENDENCY`
 * - `TOO_EARLY`
 * - `UPGRADE_REQUIRED`
 * - `PRECONDITION_REQUIRED`
 * - `TOO_MANY_REQUESTS`
 * - `REQUEST_HEADER_FIELDS_TOO_LARGE`
 * - `UNAVAILABLE_FOR_LEGAL_REASONS`
 * - `INTERNAL_SERVER_ERROR`
 * - `NOT_IMPLEMENTED`
 * - `BAD_GATEWAY`
 * - `SERVICE_UNAVAILABLE`
 * - `GATEWAY_TIMEOUT`
 * - `HTTP_VERSION_NOT_SUPPORTED`
 * - `VARIANT_ALSO_NEGOTIATES`
 * - `INSUFFICIENT_STORAGE`
 * - `LOOP_DETECTED`
 * - `BANDWIDTH_LIMIT_EXCEEDED`
 * - `NOT_EXTENDED`
 * - `NETWORK_AUTHENTICATION_REQUIRED`
 */
export const enum HttpStatus {
    CONTINUE = "CONTINUE",
    SWITCHING_PROTOCOLS = "SWITCHING_PROTOCOLS",
    PROCESSING = "PROCESSING",
    CHECKPOINT = "CHECKPOINT",
    OK = "OK",
    CREATED = "CREATED",
    ACCEPTED = "ACCEPTED",
    NON_AUTHORITATIVE_INFORMATION = "NON_AUTHORITATIVE_INFORMATION",
    NO_CONTENT = "NO_CONTENT",
    RESET_CONTENT = "RESET_CONTENT",
    PARTIAL_CONTENT = "PARTIAL_CONTENT",
    MULTI_STATUS = "MULTI_STATUS",
    ALREADY_REPORTED = "ALREADY_REPORTED",
    IM_USED = "IM_USED",
    MULTIPLE_CHOICES = "MULTIPLE_CHOICES",
    MOVED_PERMANENTLY = "MOVED_PERMANENTLY",
    FOUND = "FOUND",
    /**
     * @deprecated
     */
    MOVED_TEMPORARILY = "MOVED_TEMPORARILY",
    SEE_OTHER = "SEE_OTHER",
    NOT_MODIFIED = "NOT_MODIFIED",
    /**
     * @deprecated
     */
    USE_PROXY = "USE_PROXY",
    TEMPORARY_REDIRECT = "TEMPORARY_REDIRECT",
    PERMANENT_REDIRECT = "PERMANENT_REDIRECT",
    BAD_REQUEST = "BAD_REQUEST",
    UNAUTHORIZED = "UNAUTHORIZED",
    PAYMENT_REQUIRED = "PAYMENT_REQUIRED",
    FORBIDDEN = "FORBIDDEN",
    NOT_FOUND = "NOT_FOUND",
    METHOD_NOT_ALLOWED = "METHOD_NOT_ALLOWED",
    NOT_ACCEPTABLE = "NOT_ACCEPTABLE",
    PROXY_AUTHENTICATION_REQUIRED = "PROXY_AUTHENTICATION_REQUIRED",
    REQUEST_TIMEOUT = "REQUEST_TIMEOUT",
    CONFLICT = "CONFLICT",
    GONE = "GONE",
    LENGTH_REQUIRED = "LENGTH_REQUIRED",
    PRECONDITION_FAILED = "PRECONDITION_FAILED",
    PAYLOAD_TOO_LARGE = "PAYLOAD_TOO_LARGE",
    /**
     * @deprecated
     */
    REQUEST_ENTITY_TOO_LARGE = "REQUEST_ENTITY_TOO_LARGE",
    URI_TOO_LONG = "URI_TOO_LONG",
    /**
     * @deprecated
     */
    REQUEST_URI_TOO_LONG = "REQUEST_URI_TOO_LONG",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    REQUESTED_RANGE_NOT_SATISFIABLE = "REQUESTED_RANGE_NOT_SATISFIABLE",
    EXPECTATION_FAILED = "EXPECTATION_FAILED",
    I_AM_A_TEAPOT = "I_AM_A_TEAPOT",
    /**
     * @deprecated
     */
    INSUFFICIENT_SPACE_ON_RESOURCE = "INSUFFICIENT_SPACE_ON_RESOURCE",
    /**
     * @deprecated
     */
    METHOD_FAILURE = "METHOD_FAILURE",
    /**
     * @deprecated
     */
    DESTINATION_LOCKED = "DESTINATION_LOCKED",
    UNPROCESSABLE_ENTITY = "UNPROCESSABLE_ENTITY",
    LOCKED = "LOCKED",
    FAILED_DEPENDENCY = "FAILED_DEPENDENCY",
    TOO_EARLY = "TOO_EARLY",
    UPGRADE_REQUIRED = "UPGRADE_REQUIRED",
    PRECONDITION_REQUIRED = "PRECONDITION_REQUIRED",
    TOO_MANY_REQUESTS = "TOO_MANY_REQUESTS",
    REQUEST_HEADER_FIELDS_TOO_LARGE = "REQUEST_HEADER_FIELDS_TOO_LARGE",
    UNAVAILABLE_FOR_LEGAL_REASONS = "UNAVAILABLE_FOR_LEGAL_REASONS",
    INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
    NOT_IMPLEMENTED = "NOT_IMPLEMENTED",
    BAD_GATEWAY = "BAD_GATEWAY",
    SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",
    GATEWAY_TIMEOUT = "GATEWAY_TIMEOUT",
    HTTP_VERSION_NOT_SUPPORTED = "HTTP_VERSION_NOT_SUPPORTED",
    VARIANT_ALSO_NEGOTIATES = "VARIANT_ALSO_NEGOTIATES",
    INSUFFICIENT_STORAGE = "INSUFFICIENT_STORAGE",
    LOOP_DETECTED = "LOOP_DETECTED",
    BANDWIDTH_LIMIT_EXCEEDED = "BANDWIDTH_LIMIT_EXCEEDED",
    NOT_EXTENDED = "NOT_EXTENDED",
    NETWORK_AUTHENTICATION_REQUIRED = "NETWORK_AUTHENTICATION_REQUIRED",
}

export const enum DiscountType {
    GENERAL = "GENERAL",
    FOR_AGENT = "FOR_AGENT",
    FOR_LOCATION = "FOR_LOCATION",
    FOR_CLIENT = "FOR_CLIENT",
}

export const enum DiscountStateType {
    CREATING = "CREATING",
    SETTING_DEFINITION = "SETTING_DEFINITION",
    FORMING = "FORMING",
    PREPARED = "PREPARED",
    VERIFIED = "VERIFIED",
    REJECTED = "REJECTED",
    ACTIVATED = "ACTIVATED",
    DEACTIVATED = "DEACTIVATED",
    CLOSED = "CLOSED",
    DELETED = "DELETED",
}

export const enum PricelistType {
    GENERAL = "GENERAL",
    FOR_AGENT = "FOR_AGENT",
    FOR_LOCATION = "FOR_LOCATION",
    FOR_CLIENT = "FOR_CLIENT",
}

export const enum PricelistStateType {
    CREATING = "CREATING",
    SETTING_DEFINITION = "SETTING_DEFINITION",
    FORMING = "FORMING",
    PREPARED = "PREPARED",
    VERIFIED = "VERIFIED",
    REJECTED = "REJECTED",
    ACTIVATED = "ACTIVATED",
    DEACTIVATED = "DEACTIVATED",
    CLOSED = "CLOSED",
    DELETED = "DELETED",
}

export const enum RequestUserType {
    Undefined = "Undefined",
    ProviderUser = "ProviderUser",
    MasterAgentUser = "MasterAgentUser",
    MasterAgentService = "MasterAgentService",
    WebMasterAgentUser = "WebMasterAgentUser",
    AgentUser = "AgentUser",
    AgentService = "AgentService",
    WebAgentUser = "WebAgentUser",
    MerchantUser = "MerchantUser",
    MerchantService = "MerchantService",
    WebMerchantUser = "WebMerchantUser",
}

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}


// Added by 'AxiosClientExtension' extension

import axios from "axios";
import * as Axios from "axios";

declare module "axios" {
    export interface GenericAxiosResponse<R> extends Axios.AxiosResponse {
        data: R;
    }
}

class AxiosHttpClient implements HttpClient<Axios.AxiosRequestConfig> {

    constructor(private axios: Axios.AxiosInstance) {
    }

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: Axios.AxiosRequestConfig; }): RestResponse<R> {
        function assign(target: any, source?: any) {
            if (source != undefined) {
                for (const key in source) {
                    if (source.hasOwnProperty(key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        }

        const config: Axios.AxiosRequestConfig = {};
        config.method = requestConfig.method as typeof config.method;  // `string` in axios 0.16.0, `Method` in axios 0.19.0
        config.url = requestConfig.url;
        config.params = requestConfig.queryParams;
        config.data = requestConfig.data;
        assign(config, requestConfig.options);
        const copyFn = requestConfig.copyFn;

        const axiosResponse = this.axios.request(config);
        return axiosResponse.then(axiosResponse => {
            if (copyFn && axiosResponse.data) {
                (axiosResponse as any).originalData = axiosResponse.data;
                axiosResponse.data = copyFn(axiosResponse.data);
            }
            return axiosResponse;
        });
    }
}

export class AxiosRestApplicationClient extends RestApplicationClient<Axios.AxiosRequestConfig> {

    constructor(baseURL: string, axiosInstance: Axios.AxiosInstance = axios.create()) {
        axiosInstance.defaults.baseURL = baseURL;
        super(new AxiosHttpClient(axiosInstance));
    }
}
